var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#2775CA",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.2 9.267c0-1.166-.7-1.566-2.1-1.733-1-.133-1.2-.4-1.2-.867 0-.466.334-.766 1-.766.6 0 .934.2 1.1.7a.25.25 0 0 0 .234.166h.533c.134 0 .234-.1.234-.233v-.033a1.665 1.665 0 0 0-1.5-1.367v-.8c0-.133-.1-.233-.267-.267h-.5c-.133 0-.233.1-.267.267v.767c-1 .133-1.633.8-1.633 1.633 0 1.1.667 1.533 2.067 1.7.933.167 1.233.367 1.233.9s-.467.9-1.1.9c-.867 0-1.167-.367-1.267-.867-.033-.133-.133-.2-.233-.2h-.567c-.133 0-.233.1-.233.234v.033c.133.833.667 1.433 1.767 1.6v.8c0 .133.1.233.266.267h.5c.134 0 .234-.1.267-.267v-.8c1-.167 1.667-.867 1.667-1.767Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.3 12.767c-2.6-.933-3.933-3.833-2.966-6.4.5-1.4 1.6-2.466 2.967-2.966.133-.067.2-.167.2-.334v-.466c0-.134-.067-.234-.2-.267-.034 0-.1 0-.134.033-3.166 1-4.9 4.367-3.9 7.534a5.996 5.996 0 0 0 3.9 3.9c.134.066.267 0 .3-.134.034-.033.034-.066.034-.133v-.467c0-.1-.1-.233-.2-.3Zm3.534-10.4c-.133-.066-.267 0-.3.134-.033.033-.033.066-.033.133v.467c0 .133.1.266.2.333 2.6.933 3.933 3.833 2.966 6.4a4.93 4.93 0 0 1-2.966 2.967c-.134.066-.2.166-.2.333v.467c0 .133.066.233.2.266.033 0 .1 0 .133-.033 3.167-1 4.9-4.367 3.9-7.533a6.046 6.046 0 0 0-3.9-3.934Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdc);
export default __webpack_public_path__ + "static/media/usdc.8aa76df3b67b082fbdd26a2db388a2de.svg";
export { ForwardRef as ReactComponent };